import React from "react";
import {Typography, Col, Input, Row, Select, Form, Button, Modal, InputNumber, Radio} from "antd";
import BaseComponent from "../../redare/components/BaseComponent";
import { PlusOutlined } from '@ant-design/icons';
import ApplicationPresenter from "../../.gen/presenter/ApplicationPresenter";
import {ifTrue} from "../../redare/utils/Utils";
import RoleSelect from "../../redare_components/webplatform_workbench/components/role/RoleSelect";
import UploadImg from "../../components/common/UploadImg";
import RadioGroup from "antd/es/radio/group";
import TreeSelect from "../../redare/components/common/TreeSelect";

const {Text} = Typography;
const {TextArea} = Input;

export default class ApplicationCommonForm extends BaseComponent {
    static defaultProps={
        onAddSuccess:undefined,//添加回调
        onEditSuccess:undefined//编辑回调
    }
    formDataExt = {};
    constructor(props) {
        super(props);
        this.applicationPresenter=new ApplicationPresenter(this);
        this._user = window._workbench._user;
        this._form.platform = this._user.platform;
        this.state = {loading:false};
    }

    componentDidMount() {
        this._loadOrgInfo();
        if (ifTrue(this.props.id)) {
            this.applicationPresenter.getApplication({id: this.props.id}, {}, (result) => {
                this.formRef.setFieldsValue(result.data);
                if(result.data.icon){
                    this.uploadImg._setPreviewImg(result.data.icon);
                }
                this.setState({radioValue:result.data.showPage});
                this.setState({data: result.data});
            });
        }
    }

    _loadOrgInfo(){
        this.organizationManagePresenter.findOrganizationTree({},(result)=>{
            this.setState({treeData:result.data});
        })
    }

    //关闭窗口
    _closeForm() {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }
    //保存
    _onSubmit() {
        this.setState({loading:true});
        this.formRef.validateFields()
            .then(values=>{
                let formDataExt = this.formDataExt;
                let icon = this.uploadImg.state.previewImage;
                formDataExt.icon=icon;
                if (values.showApp === undefined){
                    values.showApp = 0;
                }
                if (values.showPage === undefined){
                    values.showPage = 0;
                }
                if (values.status === undefined){
                    values.status = 1;
                }
                if (values.isShowApp === undefined){
                    values.isShowApp = 1;
                }
                if (values.isShowPC === undefined){
                    values.isShowPC = 1;
                }
                //新增
                if (this.props.onAddSuccess) {
                    let saveData={...values,...formDataExt}
                    this.applicationPresenter.addApplication(saveData,{},(result)=>{
                        this.setState({loading:false});
                        this.toastSuccess("添加成功!");
                        this.props.onAddSuccess();
                    });

                }
                //修改
                if (this.props.onEditSuccess) {
                    let {data}=this.state;
                    let saveData={};
                    if(data){
                        data.roleIds = undefined;
                        data.orgIds = undefined;
                        data.pcRoleIds = undefined;
                        data.pcOrgIds = undefined;
                        saveData = {...data, ...values,...formDataExt};
                    }
                    this.applicationPresenter.editApplication(saveData,{},(result)=>{
                        this.setState({loading:false});
                        this.toastSuccess("修改成功!");
                        this.props.onEditSuccess();
                    });
                }
            }).catch(fail_re => {

        });


    }

    _RadioChange(e){
        this.setState({radioValue:e.target.value})
    }

    render() {
        let defaultRules = function (title, type) {
            if (!type) {
                type = '输入'
            }
            return [{required: true, message: '请' + type + title}];
        };

        let {radioValue} = this.state;
        if (!radioValue){
            radioValue = 0;
        }

        let {treeData} = this.state;
        if (!treeData){
            treeData = [];
        }

        const tProps = {
            treeData,
            treeCheckable: true,
            placeholder: '请选择可访问单位',
            style: {
                width: '100%',
            },
        };

        return (
            <>
                <Form labelAlign='right' layout='vertical' ref={(o)=>this.formRef=o}>
                    <Form.Item label="应用名称" name="name" rules={[{required:true,message:'应用名称不能为空'}]}>
                        <Input placeholder="请输入应用名称" />
                    </Form.Item>
                    <Form.Item label="应用图标" name="icon" >
                        <UploadImg ref={(the) => {
                            this.uploadImg = the
                        }}/>
                    </Form.Item>
                    <Form.Item label="分类" name="classify" rules={[{required:true,message:'分类不能为空'}]}>
                        <Select placeholder="应用分类">
                            <Select.Option value="eventcenter">事件中心</Select.Option>
                            <Select.Option value="application">应用</Select.Option>
                            <Select.Option value="datacenter">数据中心</Select.Option>
                        </Select>
                    </Form.Item>

                    <Form.Item label="移动端可访问用户角色" name="roleIdList" trigger="onValueChange" validateTrigger="onValueChange">
                        <RoleSelect platform={this._form.platform}/>
                    </Form.Item>

                    <Form.Item label="移动端可访问单位" name="orgIdList">
                        <TreeSelect {...tProps}/>
                    </Form.Item>


                    <Form.Item label="pc端可访问用户角色" name="pcRoleIdList" trigger="onValueChange" validateTrigger="onValueChange">
                        <RoleSelect platform={this._form.platform}/>
                    </Form.Item>

                    <Form.Item label="pc端可访问单位" name="pcOrgIdList">
                        <TreeSelect {...tProps}/>
                    </Form.Item>

                    <Form.Item name="isShowApp" label="是否在手机端应用显示" >
                        <RadioGroup defaultValue={1}>
                            <Radio value={0}>否</Radio>
                            <Radio value={1}>是</Radio>
                        </RadioGroup>
                    </Form.Item>

                    <Form.Item name="isShowPC" label="是否在PC端应用显示" >
                        <RadioGroup defaultValue={1}>
                            <Radio value={0}>否</Radio>
                            <Radio value={1}>是</Radio>
                        </RadioGroup>
                    </Form.Item>

                    {/*<Form.Item label="排序" name="sort">*/}
                    {/*    <InputNumber placeholder="请输入排序值(值为数字，根据数字大小升序排序)" />*/}
                    {/*</Form.Item>*/}
                    <Form.Item label="备注" name="remark">
                        <TextArea rows={4} />
                    </Form.Item>
                </Form>
                <div className="ant-modal-footer" style={{marginTop:'16px'}}>
                    <div>
                        <Row type="flex" justify="end">
                            <Col>
                                <Button onClick={this._closeForm.bind(this)}>
                                    取消
                                </Button>
                            </Col>
                            <Col offset={1}>
                                <Button type="primary" loading={this.state.loading} onClick={this._onSubmit.bind(this)}>
                                    保存
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </div>
            </>
        )
    }
}
